import { ClbCheckbox } from "@celebration/react/ClbCheckbox/ClbCheckbox";
import type { CheckboxProps } from "@components/contracts/Checkbox.types";
import type React from "react";

export const CelebrationCheckbox: React.FC<CheckboxProps> = ({
  label,
  ...props
}) => <ClbCheckbox label={label as string} {...props} />;
